import {
  Fab,
  Slide,
  useMediaQuery,
  useScrollTrigger,
  useTheme,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import scrollTo from 'gatsby-plugin-smoothscroll';
import React from 'react';
import classNames from 'classnames';

const useStyles = makeStyles()((theme) => ({
  fab: {
    position: 'fixed',
    bottom: 16,
    right: 16,
    cursor: 'pointer',
    zIndex: theme.zIndex.drawer,
    backgroundColor: theme.palette.primary.main,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: theme.shadows[8],
    transition: `${theme.transitions.create(
      ['background-color', 'box-shadow', 'transform'],
      {
        duration: theme.transitions.duration.shorter,
      },
    )} !important`,
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
      boxShadow: theme.shadows[16],
    },
  },
  anchor: { textDecoration: 'none', color: 'black' },
}));

function HideOnScroll(props: {
  children: React.ReactElement;
  window?: () => Window;
}) {
  const { children, window } = props;

  // disableHysteresis: Dont show the button if the site is scrolled up all the way
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
  });

  return (
    <Slide appear={false} direction="up" in={trigger}>
      {children}
    </Slide>
  );
}

function MoveUpFAB({ className }: { className?: string }) {
  const { classes } = useStyles();

  const theme = useTheme();
  const isBigScreen = useMediaQuery(theme.breakpoints.up('sm'));
  if (!isBigScreen) return null;

  return (
    <HideOnScroll>
      <Fab
        color="primary"
        aria-label="add"
        className={classNames(className, classes.fab)}
        onClick={() => scrollTo('#top')}
      >
        <ArrowUpwardIcon height={40} width={40} />
      </Fab>
    </HideOnScroll>
  );
}

export default MoveUpFAB;
